<div class="locale-selector">
  <evc-nav-button type="icon" size="md" variant="semi" (click)="toggleMenu()" [selected]="isMenuOpen()">
    <span class="selected-locale">
      <span class="locale-code">{{ selectedLocale().displayCode }}</span>
      <evc-svg-icon size="sm" icon="angle-down"></evc-svg-icon>
    </span>
  </evc-nav-button>

  @if (isMenuOpen()) {
    <evc-dropdown-menu
      evcCloseOnClickOutside
      class="locale-menu"
      [menuConfig]="menuConfig"
      (clickedOutside)="closeMenu()"
      (itemClicked)="closeMenu()"
    />
  }
</div>
